export const appearanceNoneStyle = `
  appearance: none;
`;